import React from 'react'
import styled from 'react-emotion'

const QuestionCount = styled.div`
  display: inline-block;
  width: 28px;
  text-align: right;
  margin-right: 7px;
`

const QuestionCounts = ({ unidentified, identified, className }) => (
  <ul className={className}>
    <li>
      <QuestionCount>{identified}</QuestionCount> Identified
    </li>
    {unidentified ? (
      <li>
        <QuestionCount>{unidentified}</QuestionCount> Unidentified
      </li>
    ) : null}
  </ul>
)

export default styled(QuestionCounts)`
  list-style: none;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  font-size: 16px;

  li {
    margin-bottom: 7px;

    &:last-child {
      margin-bottom: 0px;
    }

    &:n-child(2) {
      color: #91465f;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Editor/ConfirmationModal/QuestionCounts.js